module.exports = __webpack_public_path__ + "static/img/1.52a160e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/1.png
// module id = wpmm
// module chunks = 1